import { FC } from 'react';

import Button from '../Button';
import { IconButtonProps } from './types';

const IconButton: FC<React.PropsWithChildren<IconButtonProps>> = ({
  children,
  disabled = false,
  isLoading = false,
  size = 'medium',
  variant = 'main',
  ...rest
}) => {
  return (
    <Button
      {...rest}
      size={size}
      variant={variant}
      isLoading={isLoading}
      disabled={disabled}
      startIcon={children}
    ></Button>
  );
};

export default IconButton;
